import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingSixSlice = createSlice({
  name: 'customCounsellingSix',
  initialState: {
    allDataSix: null,
  },
  reducers: {
    setAllDataSix: (state, action) => {
      state.allDataSix = action.payload;
    },
  },
});

export const { setAllDataSix } = customCounsellingSixSlice.actions;
export default customCounsellingSixSlice.reducer;
